import { useEffect, useState } from 'react';
import { actions } from '../../actions';
import { web3 } from '../../web3';

interface AssetPriceComponentProps {
  record: { assetAddress?: string };
}

export function AssetPriceComponent({ record }: AssetPriceComponentProps) {
  const [price, setPrice] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    async function getAssetPrice(): Promise<void> {
      if (!record?.assetAddress) {
        setIsLoading(false);
        return;
      }

      const attemptCall = async (): Promise<void> => {
        const maxRetries = 3;
        let retryCount = 0;

        while (retryCount < maxRetries) {
          try {
            await new Promise((resolve) => setTimeout(resolve, 100));

            const contractInstance = await actions.getPropertyAssetContract(record.assetAddress);
            if (!contractInstance) {
              throw new Error('Failed to initialize contract');
            }

            const priceResult: string = await contractInstance.methods.assetPrice().call();
            const result = web3.utils.fromWei(priceResult.toString(), 'ether');

            setPrice(Number(result).toFixed(2));
            setIsLoading(false);
            return;
          } catch (error) {
            retryCount++;
            console.log(`Error getting asset price (attempt ${retryCount}/${maxRetries}):`, error);

            if (retryCount >= maxRetries) {
              setPrice('0.00');
              setIsLoading(false);
            } else {
              await new Promise((resolve) => setTimeout(resolve, 1000 * retryCount));
            }
          }
        }
      };

      attemptCall();
    }

    getAssetPrice();
  }, [record?.assetAddress]);

  return <span>{isLoading ? 'Loading...' : `${price} USDT`}</span>;
}
